import { EstiloSegmento } from "./estilo-segmento.model";
import { TipoSegmento } from "./tipo-segmento.model";

export class ArvoreEstilos {
    protected noDefault: NoEstilo;
    public noGlobal: NoEstilo;
    protected nosTipoSegmento: NoEstilo[] = [];

    constructor (tiposSegmento: TipoSegmento[]) {
        this.inicializarNoDefault();
        tiposSegmento.sort((a, b) => a.idTipoSegmento - b.idTipoSegmento);
        for (const tipoSegmento of tiposSegmento) {
            this.incluirNoTipoSegmento(tipoSegmento);
        }
    }

    protected inicializarNoDefault() {
        const no = new NoEstilo(null, null, null);
        no.addValorAtributo('color', 'black');
        no.addValorAtributo('font-family', 'Arial, Helvetica, sans-serif');
        no.addValorAtributo('font-size', '10pt');
        no.addValorAtributo('text-transform', 'none');
        no.addValorAtributo('text-align', 'justify');
        no.addValorAtributo('font-weight', 'normal');
        no.addValorAtributo('font-style', 'normal');
        no.addValorAtributo('text-decoration', 'none');
        no.addValorAtributo('padding', '8px 0 0 0');
        no.addValorAtributo('width', '100%');
        no.addValorAtributo('text-indent', '0px');
        no.addValorAtributo('position', 'relative');
        no.addValorAtributo('line-height', '140%');
        no.addValorAtributo('clear', 'left');
        this.noDefault = no;
    }

    public incluirNoTipoSegmento(tipoSegmento: TipoSegmento): NoEstilo {
        if (tipoSegmento.idTipoSegmento === 0) {
            this.noGlobal = new NoEstilo(this.noDefault, null, tipoSegmento.estiloSegmento);
            return this.noGlobal;
        }
        const no = new NoEstilo(this.noGlobal, tipoSegmento.idTipoSegmento, tipoSegmento.estiloSegmento);
        this.nosTipoSegmento.push(no);
        return no;
    }

    public incluirNoSegmento(idTipoSegmento: number | null, estiloSegmento: EstiloSegmento): NoEstilo | null {
        const noTipo = this.nosTipoSegmento.find(n => n.idTipoSegmento == idTipoSegmento);
        if (noTipo) {
            const no = new NoEstilo(noTipo, null, estiloSegmento);
            return no;
        }
        return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getStyle(idTipoSegmento: number | null, deep: boolean) : any {
        const noTipo = this.nosTipoSegmento.find(n => n.idTipoSegmento == idTipoSegmento);
        if (noTipo) {
            return noTipo.getStyle(deep);
        }
        return {};
    }

}

export class NoEstilo {
    public idTipoSegmento: number | null;
    protected pai: NoEstilo | null; // Referência para a entidade superior (pai)
    protected atributos: ValorAtributo[] = [];

    constructor(pai: NoEstilo | null, idTipoSegmento: number | null, estilo: EstiloSegmento | null) {
        this.pai = pai;
        if (idTipoSegmento) {
            this.idTipoSegmento = idTipoSegmento;
        }
        if (estilo) {
            for (const atributo of estilo.atributos) {
                this.addValorAtributo(atributo.atributo, atributo.valor);
            }
        }
    }

    public addValorAtributo(atributo: string, valor: string) {
        const a = new ValorAtributo();
        a.atributo = atributo;
        a.valor = valor;
        this.atributos.push(a);
    }

    public getValorSetado(atributo: string): string | null {
        const index = this.atributos.findIndex(a => a.atributo == atributo);
        if (index >= 0) {
            return this.atributos[index].valor;
        }
        return null;
    }

    public getValorHerdado(atributo: string): string | null {
        if (this.pai == null) {
            return null;
        }
        const valor = this.pai.getValorSetado(atributo);
        if (valor != null) {
            return valor;
        }
        return this.pai.getValorHerdado(atributo);
    }

    public getVA(atributo: string, label: string, listaLabels?: string[], listaValores?: string[]): ValorAtributoEdicao {
        const va = new ValorAtributoEdicao();
        va.atributo = atributo;
        const valorSetado = this.getValorSetado(atributo);
        if (valorSetado) {
            va.setado = valorSetado;
        }
        va.herdado = this.getValorHerdado(atributo);
        va.checked = valorSetado != null;
        va.label = label;
        if (listaLabels) {
            va.listaLabels = listaLabels;
        }
        if (listaValores) {
            va.listaValores = listaValores;
        }
        return va;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getStyle(deep: boolean) : any {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const style: any = {};
        let no: NoEstilo | null;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        for (no = this; no?.pai != null || (deep && no != null); no = no.pai) {
            for (const a of no.atributos) {
                if (!style[a.atributo]) {
                    style[a.atributo] = a.valor;
                }
            }
        }
        return style;
    }
}

export class ValorAtributo {
    atributo: string;
    valor: string;
}

export class ValorAtributoEdicao {
    atributo: string;
    checked: boolean;
    setado: string | null;
    herdado: string | null;
    label: string;
    listaLabels: string[];
    listaValores: string[];
}

